import {
	createAsyncThunk,
	createEntityAdapter,
	createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import * as Models from "./models";
import * as Config from "./serverConfig";
// [DISABLED] Nominatim reverse geocoding — 暂时停用，服务配置有问题
// import { Nominatim } from "./NominatimReserveGeocoding";

export const getTrucks = createAsyncThunk("trucks/getTrucks", async () => {
	const link = Config.Server?.link + "mode=getTrucksStat";
	let dataList = [];

	const response = await axios.get(link);
	const json = await response.data;

	if (json.success) {
		// [DISABLED] Nominatim reverse geocoding 已停用
		// 如需重新启用，取消注释 Nominatim import 并恢复下方的地址查询逻辑
		dataList = json.data.map((item) => {
			item.address = "";
			item.region = "";
			return new Models.TruckModel(item);
		});
		return dataList;
	} else {
		return {};
	}
});

const trucksAdapter = createEntityAdapter({});

export const { selectAll: selectTrucks, selectById: selectTruckById } =
	trucksAdapter.getSelectors((state) => state.trucks);

const Slice = createSlice({
	name: "trucks",
	initialState: trucksAdapter.getInitialState({
		searchText: "",
	}),
	reducers: {
		setTrucksSearchText: {
			reducer: (state, action) => {
				state.searchText = action.payload;
			},
			prepare: (event) => ({ payload: event.target.value || "" }),
		},
	},
	extraReducers: {
		[getTrucks.fulfilled]: trucksAdapter.setAll,
		// [removeMerchants.fulfilled]: (state, action) =>
		//   trucksAdapter.removeMany(state, action.payload),
	},
});

export const { setTrucksSearchText } = Slice.actions;

export const selectTrucksSearchText = ({ trucks }) => trucks.searchText;

export default Slice.reducer;
